export const CHATBOT_GREETING =
  "Hi, I'm the ZenFresh Assistant. Ask me about delivery areas, freshness, compliance, our products, or paste your order reference (e.g. ZP-ORD-2026-00012345) to check its status — I'll answer from our published info, or point you to a real person if I'm not sure.";

// Verbatim entries from src/data/faq.ts, not paraphrased — useChatbotEngine's
// scorer gives an exact title match its highest confidence tier (100), so
// these are guaranteed to return the real stored answer, not just "probably"
// match something. An earlier version paraphrased two of these into
// natural-language questions about topics outside the FAQ set ("What's your
// FSSAI licence number?", "Do you have sustainability certifications?") —
// those never scored above CONFIDENCE_THRESHOLD (the word-overlap fallback
// tier for a multi-word natural sentence gets diluted by filler words like
// "what's"/"your"/"do"/"have" that don't match anything), so tapping them
// silently produced the low-confidence fallback instead of a real answer.
export const EXAMPLE_QUESTIONS = [
  "Which areas do you deliver to?",
  "How is freshness guaranteed?",
  "Can I choose a specific fisherman or boat?",
  "What if I'm not home for delivery?",
];

export const CHATBOT_NAME = "ZenFresh Assistant";
